import React from 'react';
import MuiPopper, { PopperProps } from '@mui/material/Popper';

const Popper = React.forwardRef<HTMLDivElement, PopperProps>((props, ref) => {
  return props.open ? <MuiPopper ref={ref} {...props} /> : null;
});

export { PopperProps };
export default Popper;
